// Single source for the portal sidebar and the overview page headings.
export type OverviewSection = 'flow' | 'statistiek' | 'flowplanner' | 'credentials' | 'settings' | 'license';

export const HANDLEIDING_URL = 'https://simplexconnect.nl/help/';
export const SUPPORT_CENTER_URL = 'https://portal.simplex.nl';

export interface NavItem {
    label: string;
    icon: string;
    to?: string;
    href?: string;
    external?: boolean;
    adminOnly?: boolean;
    superAdminOnly?: boolean;
}

export interface NavGroup {
    caption: string;
    items: Array<NavItem>;
}

export interface SectionMeta {
    title: string;
    description: string;
    icon: string;
    adminOnly?: boolean;
}

export const overviewSections: Record<OverviewSection, SectionMeta> = {
    flow: {
        title: 'Flows',
        description: 'Beheer, open en monitor de Flows van je organisatie.',
        icon: 'fas fa-project-diagram',
    },
    statistiek: {
        title: 'Statistiek',
        description: 'Gebruik en recente uitvoeringen van je Flows.',
        icon: 'fas fa-chart-line',
    },
    flowplanner: {
        title: 'Flow Planner',
        description: 'Plan Flows in, start ze eenmalig of koppel ze aan een Endpoint.',
        icon: 'fas fa-clock',
    },
    credentials: {
        title: 'Wachtwoorden & Tokens',
        description: 'Versleuteld opgeslagen wachtwoorden, tokens en integraties.',
        icon: 'fas fa-lock',
    },
    settings: {
        title: 'Instellingen',
        description: 'Import/export, profiel, e-mail, organisatie en kantoortijden.',
        icon: 'fas fa-cog',
    },
    license: {
        title: 'Licentie',
        description: 'Bekijk en wijzig het abonnement van je organisatie.',
        icon: 'fas fa-receipt',
        adminOnly: true,
    },
};

export const isOverviewSection = (value: unknown): value is OverviewSection =>
    typeof value === 'string' && value in overviewSections;

const sectionItem = (key: OverviewSection): NavItem => ({
    label: overviewSections[key].title,
    icon: overviewSections[key].icon,
    to: `/overview/${key}`,
    adminOnly: overviewSections[key].adminOnly,
});

export const navigation: Array<NavGroup> = [
    {
        caption: 'Overzicht',
        items: [sectionItem('flow'), sectionItem('statistiek'), sectionItem('flowplanner')],
    },
    {
        caption: 'Beheer',
        items: [
            sectionItem('credentials'),
            sectionItem('settings'),
            sectionItem('license'),
            { label: 'Admin', icon: 'fas fa-user-shield', to: '/admin', superAdminOnly: true },
        ],
    },
    {
        caption: 'Hulp',
        items: [
            { label: 'Documentatie', icon: 'fas fa-book', to: '/docs' },
            { label: 'Handleiding', icon: 'fas fa-book-open', href: HANDLEIDING_URL, external: true },
            { label: 'Support Center', icon: 'fas fa-life-ring', href: SUPPORT_CENTER_URL, external: true },
            { label: 'AppStore', icon: 'fas fa-th-large', href: 'https://app.simplexconnect.nl', external: false },
        ],
    },
];

export const APPSTORE_ORGANIZATIONS_URL = 'https://app.simplexconnect.nl/?screen=organizations';
